import { useLocation, useNavigate } from "react-router-dom";
import {
	faCopy,
	faEdit,
	faList,
	faTrash,
} from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	Button,
	Checkbox,
	Flex,
	Popconfirm,
	Table,
	Tag,
	notification,
} from "antd";
import { useTableScrollOnTop } from "../../../../providers/CustomTableFilter";

export default function TableEvaluation(props) {
	const {
		dataSource,
		onChangeTable,
		setToggleModalForm,
		isLoadingChangeStatus,
		handleChangeStatus,
		handleDelete,
		isLoadingDeleteForm,
		handleDuplicate,
		isLoadingDuplicateForm,
	} = props;

	const location = useLocation();

	const navigate = useNavigate();

	useTableScrollOnTop("tbl-evaluation", location.pathname);

	return (
		<Table
			id="tbl-evaluation"
			dataSource={dataSource && dataSource.data ? dataSource.data.data : []}
			rowKey={(record) => record.id}
			pagination={false}
			bordered={false}
			onChange={onChangeTable}
			scroll={{ x: "max-content" }}
			sticky
		>
			<Table.Column
				title="Action"
				key="action"
				dataIndex="action"
				align="center"
				render={(_, record) => {
					return (
						<Flex gap={10} justify="center" align="center">
							<Button
								type="link"
								className="btn-view"
								onClick={() => navigate(`/evaluation/view/${record.id}`)}
								name="btn_preview"
								icon={<FontAwesomeIcon icon={faList} />}
							/>

							<Button
								type="link"
								className="btn-view btn-edit"
								onClick={() =>
									setToggleModalForm({
										open: true,
										data: record,
									})
								}
								name="btn_edit"
								icon={<FontAwesomeIcon icon={faEdit} />}
							/>

							<Popconfirm
								title="Are you sure to duplicate this evaluation?"
								onConfirm={() => handleDuplicate(record)}
								onCancel={() => {
									notification.error({
										message: "Evaluation",
										description: "Data not delete",
									});
								}}
								okText="Yes"
								cancelText="No"
							>
								<Button
									type="link"
									className="btn-duplicate"
									loading={isLoadingDuplicateForm}
									icon={<FontAwesomeIcon icon={faCopy} />}
									name="btn_duplicate"
								/>
							</Popconfirm>

							<Popconfirm
								title="Are you sure to delete this evaluation?"
								onConfirm={() => handleDelete(record)}
								onCancel={() => {
									notification.error({
										message: "Evaluation",
										description: "Data not delete",
									});
								}}
								okText="Yes"
								cancelText="No"
							>
								<Button
									type="link"
									className="btn-delete"
									loading={isLoadingDeleteForm}
									icon={<FontAwesomeIcon icon={faTrash} />}
									name="btn_delete"
								/>
							</Popconfirm>
						</Flex>
					);
				}}
			/>
			<Table.Column
				title="Created"
				key="created_at_formatted"
				dataIndex="created_at_formatted"
				sorter={true}
				defaultSortOrder="descend"
			/>
			<Table.Column
				title="Form Name"
				key="form_name"
				dataIndex="form_name"
				sorter={true}
				render={(text, record) => {
					return (
						<Button
							type="link"
							className="p-0 main-primary-color"
							onClick={() => navigate(`/evaluation/view/${record.id}`)}
						>
							{text}
						</Button>
					);
				}}
			/>
			<Table.Column
				title="Year"
				key="school_year"
				dataIndex="school_year"
				sorter={true}
			/>
			<Table.Column
				title="Semester"
				key="semester"
				dataIndex="semester"
				sorter={true}
			/>

			<Table.Column title="Evaluator Type" key="type" dataIndex="type" />

			<Table.Column
				title="Evaluator Role"
				key="user_role"
				render={(text, record) => {
					let user_role = record.form_user_roles
						.reduce((a, b) => {
							return [...a, b.user_role.role];
						}, [])
						.map((item, index) => <Tag key={index}>{item}</Tag>);
					return user_role;
				}}
			/>
			<Table.Column
				title="Status"
				key="status"
				dataIndex="status"
				sorter={true}
				align="center"
				render={(text, record) => {
					return (
						<Popconfirm
							title={`Are you sure to change the status of this data?`}
							onConfirm={() => handleChangeStatus(record)}
							onCancel={() => {
								notification.error({
									message: "EVALUATION",
									description: "Data status not change",
								});
							}}
							okText="Yes"
							cancelText="No"
						>
							<Checkbox
								className="btn-status"
								checked={record.status === 1 ? true : false}
								disabled={isLoadingChangeStatus}
							>
								{record.status === 1 ? "Visible" : "Not Visible"}
							</Checkbox>
						</Popconfirm>
					);
				}}
			/>
		</Table>
	);
}
